import React, { useState } from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';
import { Button } from 'react-bootstrap';

import { gray1, warning } from 'styles/global_defaults/colors';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';

// components
import NvIcon from 'shared/components/nv-icon';
import { LecturePageMode } from 'lecture_pages/components';
import { config } from '../../../../../config/config.json';

type EditModeCenterButtonProps = {
  exitToPreviousMode: (saveReorder?: boolean) => void;
};

const EditModeCenterButton = ({ exitToPreviousMode }: EditModeCenterButtonProps) => {
  const styles = css`
    .circle {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${warning};

    }
    .edit-center-button {
      border-radius: ${standardSpacing}px;
      background-color: ${gray1};
      border: none;
      box-shadow: none;
    }

    .bs4-btn-primary {
      &:hover {
        background-color: ${gray1} !important;
      }

      &:not(.disabled):focus {
        box-shadow: none !important;
      }
    }
  `;

  const params = useLecturePageParams();
  const [isHover, setIsHover] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  let buttonText;

  if (params.mode === LecturePageMode.EDIT || params.mode === LecturePageMode.LINKED_EDIT) {
    buttonText = t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.EDIT_MODE_ON();
  } else if (params.mode === LecturePageMode.RESTRICTED_EDIT) {
    buttonText = t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.ADMIN_MODE_ON();
  }

  return (
    <div css={styles}>
      <Button
        className='edit-center-button d-flex p-2 align-items-center'
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onClick={() => exitToPreviousMode()}
        aria-label={buttonText}
        data-qa={params.mode === LecturePageMode.RESTRICTED_EDIT
          ? config.pendo.lectureEdit.editMenuTopPanel.adminModeCenterButton
          : config.pendo.lectureEdit.editMenuTopPanel.editModeCenterButton}
      >
        {(isHover || isFocused)
          ? (<NvIcon icon='close' size='smallest' className='text-gray-5 mr-1' />)
          : (<div className='circle mr-1' />)}
        <span className='label text-gray-5'>{buttonText}</span>
      </Button>
    </div>
  );
};

export default EditModeCenterButton;
